module.exports = __webpack_public_path__ + "static/media/icon-dokplus.04dd9e11.png";